import { InputTableURLsTable } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { RowData } from '../../../../../../../../../baseComponents/TwinTable/types'
import { SetEditDeleteModalTy } from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import ModalPaymentMethodInfoSellTicket from './ModalPaymentMethodInfoSellTicket'
import ModalPaymentMethodInfoSellTicketRefund from './ModalPaymentMethodInfoSellTicketRefund'

interface ModalPaymentMethodInfoTPVProps {
    setOpenModal: SetEditDeleteModalTy
    allRowData?: RowData
    isRefund?: boolean
    handleCloseModal?: () => void
    inputTableURLs: InputTableURLsTable
    isReservedRefund?: boolean
}

const ModalPaymentMethodInfoTPV: React.FC<ModalPaymentMethodInfoTPVProps> = ({ isRefund, ...rest }) => {
    if (isRefund) {
        return <ModalPaymentMethodInfoSellTicketRefund {...rest} />
    }
    return <ModalPaymentMethodInfoSellTicket {...rest} />
}


export default ModalPaymentMethodInfoTPV
